import React, { ReactNode } from "react";
import { clone, remove } from "lodash";
import {
  CellProps,
  SortableCell as TableSortableCell,
} from "@sonder/ui/source/styled/fragments/Table";
import { setSortOptions } from "history/actions";
import { HistorySortColumn } from "history/reducer";
import { useStore as useHistoryStore } from "history/store";
import { SortAscDesc } from "typings/globalGQLTypes";

interface HistorySortableCellProps extends CellProps {
  children: ReactNode;
  sortKey: HistorySortColumn;
}
export const HistorySortableCell = ({
  children,
  sortKey,
  ...cellProps
}: HistorySortableCellProps) => {
  const { dispatch, state: historyState } = useHistoryStore();
  const { sort } = historyState;

  const sortInputIndex = sort.findIndex(input => input.column === sortKey);
  const sortOrder = sortInputIndex > -1 ? sort[sortInputIndex].order : null;

  const onClick = () => {
    const newSortOptions = clone(sort);

    if (sortInputIndex > -1)
      if (newSortOptions[sortInputIndex].order === SortAscDesc.asc) {
        newSortOptions[sortInputIndex] = {
          column: sortKey,
          order: SortAscDesc.desc,
        };
      } else {
        remove(newSortOptions, input => input.column === sortKey);
      }
    else
      newSortOptions.push({
        column: sortKey,
        order: SortAscDesc.asc,
      });

    dispatch(setSortOptions(newSortOptions));
  };

  return (
    <TableSortableCell {...cellProps} sortOrder={sortOrder} onClick={onClick}>
      {children}
    </TableSortableCell>
  );
};
